import styled from '@emotion/styled';
import {colors} from '@styles/colors';
import {absolutePosition} from '@styles/reusable';

export const ListItemContainer = styled.div<{ active: boolean; disabled?: boolean }>`
  position: relative;
  display: grid;
  width: 100%;
  grid-template-columns: 300px 1fr;
  margin: 0;
  height: 44px;
  /* opacity: ${({ active }) => (active ? 1 : 0.5)}; */
  filter: opacity(${({ active }) => (active ? 1 : 0.5)});

  grid-gap: 20px;
  --cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  --bgColor: ${colors.white};
  --fgColor: ${colors.mainTextColor};
  will-change: filter;
  transition: filter 0.2s ease-in-out;
`;

export const Picture = styled.div`
  position: relative;
  width: 46px;
  /* height: 50px; */
  height: calc(100% + 2px);
  margin-top: -1px;
  display: flex;
  overflow: hidden;
  flex-shrink: 0;
  border-radius: 30px;

  > svg {
    height: 44px;
  }
`;

export const CheckContainer = styled.div`
  display: grid;
  place-content: center;
  width: 50px;
`;

export const NameContainer = styled.div<{ mock?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${(props) => (props.mock ? (props) => props.theme.colors.mockColor : 'inherit')};
  flex-direction: row;
  width: 300px;
  cursor: var(--cursor);
`;

export const Schedule = styled.div<{ cols: number }>`
  display: grid;
  grid-template-columns: repeat(${({ cols }) => cols}, minmax(100px, 1fr));
  width: 100%;
  margin: 0;
  grid-gap: 20px;
`;

export const CourseCell = styled.div<{ active: boolean, backgroundColor?:boolean }>`
  position: relative;
  display: grid;
  place-content: center;
  background-color: ${props => props.backgroundColor?"#fff": "var(--backgroundColor)"};
  border-radius: ${(props) => props.theme.pillBorderRadius}px;
  cursor: var(--cursor);

  &::before {
    ${absolutePosition};
    content: ' ';
    height: 100%;
    width: 100%;
    transition: box-shadow 0.2s, border-width 0.2s;
    --test: rgb(227, 227, 227);
    box-shadow: inset 0px 0px 0px ${({ active }) => (active ? 3 : 0)}px var(--test);
    border-style: solid;
    border-width: ${({ active }) => (active ? 2 : 0)}px;
    border-color: ${colors.gray};
    border-radius: ${(props) => props.theme.pillBorderRadius}px;
    z-index: 3;
    pointer-events: none;
    overflow: visible;
  }
`;

export const PersonData = styled.p`
  color: #000;
  display: flex;
  flex-direction: column;
  font-size: 16px;
  justify-content: center;
  margin-left: 20px;
`;

export const StatusRow = styled.div`
  display:flex;
  align-items: center;
  justify-content: center;
  height:20px;
  gap:0.5rem;
`;

